import type { FunctionComponent } from 'react'
import { PayNowButton } from '../../components/Order/PayNowButton'
import { PrintInvoice } from '../../components/Order/PrintInvoice'
import { CancelOrderButton } from '../../components/Order/CancelOrderButton'
import { GoToCartButton } from '../../components/Order/GoToCartButton'

export type OrderComponentsProps = {
  PayButton?: FunctionComponent
  PrintButton?: FunctionComponent
  CancelButton?: FunctionComponent
  CheckoutButton?: FunctionComponent
}

export const orderComponents: OrderComponentsProps = {
  PayButton: PayNowButton,
  PrintButton: PrintInvoice,
  CancelButton: CancelOrderButton,
  CheckoutButton: GoToCartButton,
}
